const ru = {
  nav: {
    home: 'Главная',
    about: 'О нас',
    disciplines: 'Направления',
    goals: 'Цели',
    events: 'Мероприятия',
    documents: 'Документация',
    docs_patriot: 'Документация «Patriot»',
    contacts: 'Контакты',
    admin: 'Администрация',
    title: 'Национальная Федерация',
    subtitle: 'военно-прикладных видов спорта',
  },
  hero: {
    label: 'Национальная Федерация',
    title: 'Путь воина',
    subtitle: 'Общественная Организация «НАЦИОНАЛЬНАЯ ФЕДЕРАЦИЯ ПО ВОЕННО – ПРИКЛАДНЫМ ВИДАМ СПОРТА»',
    btn_about: 'О Федерации',
    btn_events: 'Мероприятия',
  },
  stats: {
    athletes: 'Спортсменов',
    regions: 'Регионов',
    events: 'Мероприятий в год',
    ranks: 'Спортивных разрядов',
  },
  about: {
    title: 'О Федерации',
    subtitle: 'Национальная Федерация',
    desc: 'Общественная Организация «НАЦИОНАЛЬНАЯ ФЕДЕРАЦИЯ ПО ВОЕННО – ПРИКЛАДНЫМ ВИДАМ СПОРТА» объединяет лучших атлетов страны, развивает физическую культуру и боевую готовность.',
  },
  disciplines: {
    title: 'Направления спорта',
  },
  goals: {
    title: 'Наши цели',
  },
  quote: {
    title: 'Здесь рождается сила, характер и честь.',
    text: 'Военно-прикладные виды спорта — путь к мастерству, ответственности и служению Родине.',
  },
  events: {
    title: 'Предстоящие мероприятия',
  },
  footer: {
    rights: 'Все права защищены.',
    contacts: 'Контактная информация',
  },
  admin: {
    title: 'Тексты сайта',
    save: 'Сохранить',
    saved: 'Сохранено',
    lang_kk: 'Қазақша',
    lang_ru: 'Русский',
    lang_en: 'English',
  },
};

export default ru;
